// extracted by mini-css-extract-plugin
export default {"container":"fq-z","heading":"gq-z","text":"hq-z","info":"iq-z","link":"jq-z","fullMaxWidth":"kq-z"};